import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import {dataToProductBadges} from '../parsings'

// const DUMMY_BADGES = [
//   {
//     id: '1',
//     name: 'Best Seller',
//     displayName: 'Best Seller',
//     productCount: 120,
//     status: 'active',
//     createdAt: '2024-01-01',
//     updatedAt: '2024-01-10',
//   },
//   {
//     id: '2',
//     name: 'New Arrival',
//     displayName: 'New',
//     productCount: 45,
//     status: 'inactive',
//     createdAt: '2024-02-01',
//     updatedAt: '2024-02-05',
//   },
//   {
//     id: '3',
//     name: 'Limited Edition',
//     displayName: 'Limited',
//     productCount: 10,
//     status: 'active',
//     createdAt: '2024-03-01',
//     updatedAt: '2024-03-02',
//   },
// ]

export default function useGetProductBadgesList() {
  const Api = useApi()

  const {filters, onSearch, onPageChange, onSortingChange} = useFilters(
    {
      limit: 30,
      page: 1,
      search: true,
      sort_by: 'created_at/-1',
    },
    {sortType: 'number'}
  )

  const {data: response, isFetching} = Api.useGetQuery(`/products/product-badges`, {
    queryId: 'product-badges-list',
    filters: filters,
  })

  const productBadgesList =
    response?.data && response.data.length > 0 ? dataToProductBadges(response.data) : []

  return {
    productBadgesList,
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
  }
}
